import type { AnsweredQuestion } from './QuestionAnswerSummary';

export type QuestionAnswerEntry =
  { kind: 'instruction' } | { kind: 'answer'; answer: AnsweredQuestion };

/** One card per user instruction, across plan turns and the reload boundary.
 * Assistant updates do not start a new question batch. The first answer owns
 * the card's stable position/key; later answers extend that same card. */
export function groupQuestionAnswers(entries: QuestionAnswerEntry[]) {
  const groups = new Map<string, AnsweredQuestion[]>();
  let current: AnsweredQuestion[] | undefined;
  for (const entry of entries) {
    if (entry.kind === 'instruction') {
      current = undefined;
    } else if (current) {
      current.push(entry.answer);
    } else {
      current = [entry.answer];
      groups.set(entry.answer.id, current);
    }
  }
  return groups;
}
